import { MapPin } from "lucide-react";

const zones = [
  { id: "zone-chateauguay", name: "Châteauguay", primary: true },
  { id: "zone-mercier", name: "Mercier", primary: true },
  { id: "zone-lery", name: "Léry", primary: true },
  { id: "zone-environs", name: "Environs", primary: false },
];

export const ServiceAreas = () => (
  <section id="zones" className="bg-white py-16 md:py-20" data-testid="areas-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-testid="areas-title">Zones desservies</h2>
        <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">Nous desservons fièrement les résidents de la Rive-Sud de Montréal.</p>
      </div>
      <div className="flex flex-wrap justify-center gap-3">
        {zones.map((z) => (
          <div key={z.id} className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium ${z.primary ? "bg-[#2D5A3D] text-white" : "bg-green-50 text-[#2D5A3D] border border-green-200"}`} data-testid={z.id}>
            <MapPin className="w-4 h-4" />{z.name}
          </div>
        ))}
      </div>
      <p className="text-center text-sm text-gray-500 mt-6">Vous habitez à proximité? Contactez-nous pour vérifier si nous desservons votre secteur.</p>
    </div>
  </section>
);
